import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ParentDetails } from '../model/parent.type';

export interface UpdateStudentInInvoiceParams {
  invoiceId: string;
  studentId: string;
  parentId: string;
}

export const updateStudentInInvoiceAPI = async ({
  invoiceId,
  studentId,
  parentId,
}: UpdateStudentInInvoiceParams) => {
  const response = await baseAPI.put<ParentDetails>(
    `/subscription-invoices/update-student-data/${invoiceId}`,
    {
      studentId,
      parentId,
    },
  );
  return response.data;
};

export const useUpdateStudentInInvoice = () => {
  return useMutation({
    mutationFn: (params: UpdateStudentInInvoiceParams) =>
      updateStudentInInvoiceAPI(params),

    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === KEYS.PARENT_PAYMENTS_HISTORY,
      });
      // Invoice parent/student linkage changes can affect AR grouping totals
      void queryClient.invalidateQueries({ queryKey: [KEYS.ACCOUNTS_RECEIVABLE] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
    },
  });
};
